import React from 'react'
import './portfolio.css'
import IMG2 from '../../assets/prof.png'
import IMG3 from '../../assets/peek2.png'
import IMG4 from '../../assets/postview.png'
import IMG5 from '../../assets/rec.png'
import IMG6 from '../../assets/profile.png'
import IMG7 from '../../assets/admin.png'
import IMG01 from '../../assets/1.png'
import IMG07 from '../../assets/moa.png'
import IMG02 from '../../assets/2.png'
import IMG03 from '../../assets/house.png'
import IMG04 from '../../assets/4.png'
import IMG05 from '../../assets/5.png'
import IMG06 from '../../assets/jeep.png'
import IMG08 from '../../assets/spo.png'
import IMG09 from '../../assets/link.png'
import VID1 from '../../assets/11.mp4'
import VID2 from '../../assets/12.mp4'
import VID3 from '../../assets/13.mp4'
import VID4 from '../../assets/14.mp4'
import VID5 from '../../assets/18.mp4'
import VID6 from '../../assets/17.mp4'
import VID07 from '../../assets/15.mp4'
import VID08 from '../../assets/16.mp4'
import VID09 from '../../assets/20.mp4'

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2><h1>Portfolio</h1></h2>
      <div className="white__part">
        <p>&nbsp;</p>
        <h4>Hover on an image for more details</h4>
        <h1>WEB DEVELOPMENT PROJECTS</h1>
        <p>&nbsp;</p>
      </div>
      <p>&nbsp;</p>
      <div className="container portfolio__container">
        <article className='portfolio__item'>

          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG7} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> NeighbourhoodX </h3>
              <p>This is a web application that incorporates maps and allows residents to be in the loop about everything happening in the neighborhood. You can check businesses around, You can view messages from other residents, You can add a business. You can check for Social services centers around e.g Hospital and many more. </p>
            </div>
            <h3>NeighbourhoodX</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/Neighbourhood-X" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://neighbourhoodxl.herokuapp.com/" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG07} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> Disney+ Clone </h3>
              <p> This is a Disney+ Clone made with React for the design, Redux for state management and Firebase for both authentication and data storage. This project is FrontEnd Heavy. Just a single click to login(Google).
              </p>
            </div>
            <h3>Disney + Clone</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/Disney-plus-X" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://disney-clonex.web.app/" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG3} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> GalleryX </h3>
              <p> This is a simple Gallery Website used for displaying images. It is similar to the likes of unsplash.</p>
            </div>
            <h3>GalleryX</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/Gallery-X" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://galleryxl.herokuapp.com/" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG4} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> InstaX </h3>
              <p>This is an instagram clone where the user can perform functions same as the ones on the real Instagram, e.g. Post, Like, Follow e.t.c.
              &nbsp; <br /> <br />
              This is solely made for educational purposes.
              </p>
            </div>
            <h3>Instagram Clone</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/Insta-X" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://instaxl.herokuapp.com/" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG2} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> AwwardX </h3>
              <p> This is an awwwards clone where the user can perform the same functions as the ones on the real awwwards.com site.
                It allows the user to upload their sites and let other users rate their functionalities in accordance to the specifications.
              </p>
            </div>
            <h3>Awwwards Clone</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/awwward-X" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://awwwardxl.herokuapp.com/" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG5} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> NetFlix Clone </h3>
              <p> This is an netflix clone landing page made with react. uses data from the TheMoviesDatabase.
              </p>
            </div>
            <h3>Netflix Clone</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/Netflix-Clone-React" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://github.com/Lyonsmasawa/Netflix-Clone-React" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG08} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> Spotify clone </h3>
              <p> This is a simple clone of the music streaming service known as Spotify(data from Spotify API). Made with React JS. Must have a spotify account to log in. 
              </p>
            </div>
            <h3>Spotify clone</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/Spotify-X" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://spotifyx-dev.web.app/" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG6} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> Learning Bay </h3>
              <p> This is a web application that facilitates virtual group discussions. It is meant to promote the ease of group discussions for students and also to make it easy for the instructors to monitor the progress of the discussions in addition to the participation of the group members.. Inspired by the StudyBud application.
              </p>
            </div>
            <h3>Learning Bay</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/learning-bay" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://learningbay.herokuapp.com/" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG09} alt="TITLE" />
            </div>
            <div className="writing">
              <p>&nbsp;</p>
              <h3> LinkedIn Clone </h3>
              <p> This is a simple clone of LinkedIn's page using React, Redux, Firebase and MaterialUi. This a FrontEnd Projects with just a tiny bit of backend for data storage.
              </p>
            </div>
            <h3>LinkedIn Clone</h3>
            <div className="portfolio__item-cta">
              <a href="https://github.com/Lyonsmasawa/LinkedIn-X" className='btn' target='_blank' rel='noreferrer'>Github</a>
              <a href="https://linkedin-clone-x.web.app/" className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
          </div>
        </article>

      </div>
      <p>&nbsp;</p>
      <div className="white__part">
        <p>&nbsp;</p>
        <h1>3D Models Made With Blender</h1>
        <h4>Hover on a model for more details</h4>
        <p>&nbsp;</p>
      </div>
      <p>&nbsp;</p>
      <div className="container portfolio__container">
        <article className='portfolio__item'>

          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG04} alt="TITLE" />
            </div>
            <div class="writingx">
                <h2>Modern Home with blender</h2>
                <a href="#contact"> <button className='btnx'>Hire me!</button></a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG05} alt="TITLE" />
            </div>
            <div class="writingx">
                <h2>Sitting Room interior with blender</h2>
                <a href="#contact"> <button className='btnx'>Hire me!</button></a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG02} alt="TITLE" />
            </div>
            <div class="writingx">
                <h2>Chess Scene with blender</h2>
                <a href="#contact"> <button className='btnx'>Hire me!</button></a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG06} alt="TITLE" />
            </div>
            <div class="writingx">
                <h2>Jeep Model with blender</h2>
                <a href="#contact"> <button className='btnx'>Hire me!</button></a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>

          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG01} alt="TITLE" />
            </div>
            <div class="writingx">
                <h2>Bowling scene with blender</h2>
                <a href="#contact"> <button className='btnx'>Hire me!</button></a>
            </div>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <img src={IMG03} alt="TITLE" />
            </div>
            <div class="writingx">
                <h2>Homestead made with blender</h2>
                <a href="#contact"> <button className='btnx'>Hire me!</button></a>
            </div>
          </div>
        </article>
      </div>

      <p>&nbsp;</p>
      <div className="white__part">
        <p>&nbsp;</p>
        <h1>3D Motion Graphics Made With Blender</h1>
        <h4>Don't be shy to click on the play button</h4>
        <p>&nbsp;</p>
      </div>
      <p>&nbsp;</p>

      <div className="container portfolio__container">
        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID1} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'>Modern Home made with Blender</h2>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID2} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'> Homestead made with Blender</h2>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID3} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'>Jeep Model Drive made with Blender</h2>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID4} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'>Chill Room made with Blender</h2>
          </div>
        </article>

        <article className='portfolio__item'>

          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID5} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'>Smart 3D interior made with Blender</h2>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID6} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'>Jeep model show reel made with Blender</h2>
          </div>
        </article>
      </div>


      <p>&nbsp;</p>
      <div className="white__part">
      <p>&nbsp;</p>
        <h1> 2D || Adobe Video Creation</h1>
        <h4>Don't be shy to click on the play button</h4>
      <p>&nbsp;</p>
      </div>
      <p>&nbsp;</p>
      <div className="container portfolio__container">
        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID07} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'>Channel intro Design using After Effects</h2>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID08} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'>Audio Spectrum using After effects and illustrator</h2>
          </div>
        </article>

        <article className='portfolio__item'>
          <div className="portfolio__items">
            <div className="portfolio__item-image">
              <video style={{ width: "100%" }} controls>
                <source src={VID09} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
            <h2 className='port__title'>After effects 2D model</h2>
          </div>
        </article>
      </div>
    </section>
  )
}

export default Portfolio